import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import * as urls from "../../helpers/url_helper"

const baseUrl = process.env.LOCALHOST
  ? process.env.LOCALHOST
  : "https://qa_api_gtc.amerck.com"

export const enptReportApi = createApi({
  reducerPath: "enptReportApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    timeout: 30000,
    prepareHeaders: headers => {
      const authUser = localStorage.getItem("authUser")
      if (authUser) {
        // Parse if it's a JSON string, otherwise use as is
        try {
          const parsedAuth = JSON.parse(authUser)
          headers.set("auth", parsedAuth)
        } catch (e) {
          headers.set("auth", authUser)
        }
      }
      return headers
    },
  }),
  endpoints: builder => ({
    getEnptReports: builder.query({
      query: ({
        page = 1,
        limit = 5,
        customer = "",
        operator = "",
        date = "",
        type = "",
        country = "",
      }) => {
        const queryParams = new URLSearchParams()
        const params = { page, limit, customer, operator, date, type, country }

        Object.entries(params).forEach(([key, value]) => {
          if (value) {
            queryParams.append(key, value)
          }
        })

        return {
          url: `${urls.GET_ENPT_REPORTS}?${queryParams.toString()}`,
          method: "GET",
          timeout: 30000,
        }
      },
      providesTags: ["EnptReports"],
    }),
    getEnptReport: builder.query({
      query: id => ({
        url: `${urls.GET_ENPT_REPORT}/${id}`,
        method: "GET",
        timeout: 30000,
      }),
    }),
    getEnptReportData: builder.query({
      query: ({ id, date, page = 1, limit = 200 }) => ({
        url: `${urls.GET_ENPT_REPORT_DATA}/${id}?date=${date || ''}&page=${page}&limit=${limit}`,
        method: "GET",
        timeout: 30000,
      }),
    }),
    createEnptReport: builder.mutation({
      query: reportData => ({
        url: urls.CREATE_ENPT_REPORT,
        method: "POST",
        body: reportData,
      }),
    }),
    deleteReport: builder.mutation({
      query: id => ({
        url: `${urls.DELETE_ENPT_REPORTS}/${id}`,
        method: "DELETE",
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 40000,
      }),
    }),
    deleteReportDay: builder.mutation({
      query: ({ id, date }) => ({
        url: `${urls.DELETE_ENPT_REPORT_DAY}/${id}/day/${date}`,
        method: "DELETE",
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 40000,
      }),
    }),
    downloadEnptReport: builder.query({
      query: id => ({
        url: `${urls.DOWNLOAD_ENPT_REPORT}/${id}`,
        method: "GET",
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        responseHandler: response => response.blob(),
      }),
    }),

    uploadEnptReport: builder.mutation({
      query: ({ data, url }) => ({
        url: url || urls.UPLOAD_ENPT_REPORT, // Use the provided URL or default
        method: "POST",
        body: data,
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
          // Don't set Content-Type - let the browser set it with the boundary
        },
      }),
    }),
    reassignCustomer: builder.mutation({
      query: ({ id, newCustomer }) => ({
        url: `${urls.REASSIGN_CUSTOMER}/${id}/reassignCustomer`,
        method: 'PUT',
        body: { newCustomer },
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      })
    }),
    bulkUpdateReportData: builder.mutation({
      query: ({ id, field, findValue, replaceValue }) => ({
        url: `${urls.BULK_UPDATE_REPORT}/${id}/bulkUpdate`,
        method: 'PUT',
        body: { field, findValue, replaceValue },
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      })
    }),
    updateEnptKpi: builder.mutation({
      query: ({ id, data }) => ({
        url: `${urls.UPDATE_ENPT_KPI}/${id}`,
        method: 'PUT',
        body: data,
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      })
    }),
  }),
})

export const {
  useGetEnptReportsQuery,
  useDeleteReportMutation,
  useDeleteReportDayMutation,
  useLazyDownloadEnptReportQuery,
  useUploadEnptReportMutation,
  useLazyGetEnptReportQuery,
  useLazyGetEnptReportDataQuery,
  useReassignCustomerMutation,
  useBulkUpdateReportDataMutation,
  useUpdateEnptKpiMutation,
} = enptReportApi
